import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import Capsule from "./Capsule";

export default function ({ info }) {
    const { t } = useTranslation();
    const { links = [] } = info;

    return (
        <Fragment>
            {links.length > 0 ? (
                <div className="mt-[16px]">
                    {/*<div className="flex items-center text-body1 font-Semibold text-text_1 h-[44px]">{t('coin_info_pop_resources_title')}</div>*/}
                    <div className="flex flex-wrap">
                        {links.map((item, index) => (
                            <Capsule
                                key={index}
                                type={item.name}
                                link={item.link}
                            />
                        ))}
                    </div>
                </div>
            ) : null}
        </Fragment>
    );
}
